import { connect } from 'react-redux';
import { setFilter, clearFilter } from '@store/optionsFilter/actions';
import { AsyncAutoComplete } from '../../components/autoComplete/index';

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    optionsFilter: state.optionsFilters[ownProps.name],
  };
};

const mapDispatchToProps = (dispatch: any, ownProps: any) => {
  return {
    setOptionsQuery: (value: any) => {
      dispatch(
        setFilter({
          filterKey: ownProps.name,
          filterValue: value,
        })
      );
    },
    clearFilter: (filter: any) => {
      dispatch(clearFilter(filter));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AsyncAutoComplete);
try {
    // @ts-ignore
    asyncAutoComplete.displayName = "asyncAutoComplete";
    // @ts-ignore
    asyncAutoComplete.__docgenInfo = { "description": "", "displayName": "asyncAutoComplete", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/containers/asyncAutoComplete/asyncAutoComplete.tsx#asyncAutoComplete"] = { docgenInfo: asyncAutoComplete.__docgenInfo, name: "asyncAutoComplete", path: "src/containers/asyncAutoComplete/asyncAutoComplete.tsx#asyncAutoComplete" };
}
catch (__react_docgen_typescript_loader_error) { }